// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"fb16a5a5","77":"56b56eb5","787":"97c02633"}[chunkId] + ".chunk.js";
};